



































import {Component, Vue} from "vue-property-decorator";
import {RoleStore} from "@/modules/roles/store";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import RoleTableAction from "@/modules/roles/List/components/TableAction.vue";
import {RoleParams} from "@/modules/roles/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import RoleSearch from "@/modules/roles/List/components/Search.vue";
import {RoleType} from '@/enums/type';
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 45
    },
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        scopedSlots: {customRender: 'action'},
        width: 60
    },
    {
        title: "Tên nhóm quyền",
        dataIndex: "name",
        key: "name",
        width: 200,
        ellipsis: true
    },
    {
        title: "Bưu cục/Hệ thống",
        dataIndex: "postOfficeRowGuid",
        key: "postOfficeRowGuid",
        scopedSlots: {customRender: 'postOfficeRowGuid'},
        width: 200,
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        scopedSlots: {customRender: 'status'},
        width: 120,
        ellipsis: true
    }
];

@Component({
    name: "RoleList",
    components: {RoleTableAction, RoleSearch, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = columns;
    RoleType = RoleType;

    created() {
        RoleStore.listRole(new RoleParams());
    }

    get roles() {
        return RoleStore.ids.map((id: number) => RoleStore.data[id]);
    }

    get pagination() {
        return {
            current: RoleStore.meta.page,
            pageSize: RoleStore.meta.limit,
            total: RoleStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} nhóm quyền`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        RoleStore.listRole({...RoleStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
